import React from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Container } from './components/Styled'
import { SubscribeForm } from 'app/sofia/components/SubscribeForm'

export const NewsletterForm = () => {
  return (
    <Container>
      <CmsBlock
        id={CMS_BLOCK.FOOTER_NEWSLETTER}
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            if (!process.env.REACT_APP_ENABLE_CMS_BLOCK_SAMPLE_DATA) {
              return null
            }

            return (
              <p>Get the latest updates and special offers.</p>
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
      <SubscribeForm />
    </Container>
  )
}
